export const GST_REGEX =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;
export const IFSC_REGEX = /[A-Z|a-z]{4}[0][a-zA-Z0-9]{6}$/;
export const PIN_CODE_REGEX = /^[1-9][0-9]{5}$/;
export const PAN_NUMBER_REGEX =
  /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MOBILE_NUMBER = /^([0-9/-]+\s?)*$/;
export const UGDN = /^([0-9/-]+\s?)*$/;
export const EMP_CODE = /^([0-9/-]+\s?)*$/;
export const NUMBER_UPTO_TWO_DECIMAL_PLACES =
  /^(?:\d*\.\d{1,2}|\d+)$/;
export const INTEGER_NUMBER_GREATER_THAN_0 =
  /^[1-9][0-9]*$/;
